import axios from "axios";
import { config } from "../enviroment";
import { store } from "../helpers/store";
import { bearerTokenService } from "./bearer.service";
export const appService = {
  getParametersWidgets: getParametersWidgets,
  getLabels: getLabels,
  downloadLabels: downloadLabels,
  getPremises: getPremises,
};

async function getParametersWidgets() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.urls.PARAMETER_WIDGET_CONTROL)
      .then((response) => {
        if(response){
        resolve(response.data);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

async function downloadLabels(languageCode) {
  let APIquery = `{
    getLabels(input:{languageCode: "`+languageCode+`", 
    tenantCode: "`+config.parameters.TENANT_CODE+`"})
  }`;
  return new Promise((resolve, reject) => {
    axios({
      url: config.urls.ADMIN_SERVICE_BASE_URL,
      method: "post",
      data: {
        query: APIquery,
      },
    })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

async function getPremises() {
  let ApiQuery = `{
    getPremiseFinder{
      leadId
      state
      stateDescr
      address1
      address2
      address3
      address4
    },
  }`;
  return new Promise((resolve, reject) => {
    axios({
      url: config.urls.PREMISES,
      method: "post",
      data: {
        query: ApiQuery + ``,
      },
      header: { tenantCode: config.parameters.TENANT_CODE },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        let data={
          "getPremiseFinder": [
            {
              "leadId": "09410666311105",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "3",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "20423021795710",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR10",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "21106148386889",
              "state": "MC",
              "stateDescr": "Medina Centrale",
              "address1": "VA02",
              "address2": "Villa",
              "address3": null,
              "address4": null
            },
            {
              "leadId": "22723746363434",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "1",
              "address2": "QC-504A",
              "address3": "QC-504A",
              "address4": null
            },
            {
              "leadId": "27358309979640",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR06",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "29193001052085",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "0419",
              "address2": "AH",
              "address3": "Anyng Hsy",
              "address4": null
            },
            {
              "leadId": "30583390912990",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "AR02",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "36298503180746",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "AR07",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "38767968213362",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "AR05",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "40100332199259",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR07",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "44892298301720",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "4",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "50311756003150",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "QC-490-i",
              "address2": "QC-490-i",
              "address3": "QC-490-i",
              "address4": "QC-490-i"
            },
            {
              "leadId": "57152724136122",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR04",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "69009971740347",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "QC-490-f",
              "address2": "QC-490-f",
              "address3": "QC-490-f",
              "address4": "QC-490-f"
            },
            {
              "leadId": "69348902425701",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR03",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "72703043568446",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "AR09",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "76550703105158",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "6",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "82095901524362",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "521",
              "address2": "Sitara",
              "address3": null,
              "address4": null
            },
            {
              "leadId": "83337650806544",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR21",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "83951268094616",
              "state": "MC",
              "stateDescr": "Medina Centrale",
              "address1": "VA10",
              "address2": "Villa",
              "address3": null,
              "address4": null
            },
            {
              "leadId": "84651370827023",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "C-0823ARB",
              "address2": "OREC4 TWR4",
              "address3": null,
              "address4": null
            },
            {
              "leadId": "88333945970720",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "3",
              "address2": "QC-504B",
              "address3": "QC-504B",
              "address4": null
            },
            {
              "leadId": "90693476661256",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "AA6",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "91687847630227",
              "state": "QQ",
              "stateDescr": "Qanat Quartier",
              "address1": "GF000",
              "address2": "A001",
              "address3": "Tower CCSA TPQ",
              "address4": null
            },
            {
              "leadId": "92142566854276",
              "state": "MC",
              "stateDescr": "Medina Centrale",
              "address1": "VA01",
              "address2": "Villa",
              "address3": null,
              "address4": null
            },
            {
              "leadId": "93541949644090",
              "state": "TPQ",
              "stateDescr": "The Pearl Qatar",
              "address1": "0816-1027",
              "address2": "Wohs",
              "address3": "WS",
              "address4": null
            },
            {
              "leadId": "93662993245637",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR09",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            },
            {
              "leadId": "96163736451785",
              "state": "VB",
              "stateDescr": "Viva Bahriya",
              "address1": "AR02",
              "address2": "Billing TAL",
              "address3": null,
              "address4": "Viva Bahriya Drive"
            }
          ]
        }
        resolve(data);
      });
  });
}

function getLabels() {
  var labels = store.getState().labels;
  return labels;
}
